// File Metadata:
// Filename: CrewDetails.js
// Version: 1.00
// Created: 2025-03-30 14:44:08
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useGetCrewQuery } from '../../../api/crewsApiSlice'

// ...existing code...

import { 
    Paper, 
    Typography, 
    CircularProgress,
    Grid,
    List,
    ListItem,
    ListItemText,
    Divider,
    Chip
} from '@mui/material'

const CrewDetails = ({ crewId }) => {
    const {
        data: crew,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetCrewQuery(crewId)

    const renderSchedule = (schedule) => {
        if (schedule.type === 'fixed') {
            return `${schedule.fixed.hours.start} - ${schedule.fixed.hours.end}`
        }
        return (
            <>
                <div>Even weeks: {schedule.alternating.evenWeeks.hours.start} - {schedule.alternating.evenWeeks.hours.end}</div>
                <div>Odd weeks: {schedule.alternating.oddWeeks.hours.start} - {schedule.alternating.oddWeeks.hours.end}</div>
            </>
        )
    }

    let content

    if (isLoading) {
        content = <CircularProgress />
    }

    if (isError) {
        content = <Typography color="error">{error?.data?.message}</Typography>
    }

    if (isSuccess) {
        content = (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">{crew.name}</Typography>
                    <Chip 
                        label={crew.type} 
                        color={crew.type === 'weekday' ? 'primary' : 'secondary'} 
                        size="small" 
                    />
                </Grid>
                
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1">Schedule</Typography>
                    <Paper sx={{ p: 2 }}>
                        {renderSchedule(crew.schedule)}
                        {crew.schedule.breaks?.map((break_, idx) => (
                            <div key={idx}>
                                Break: {break_.start} - {break_.end}
                                ({break_.paid ? 'Paid' : 'Unpaid'})
                            </div>
                        ))}
                    </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1">Members</Typography>
                    <Paper>
                        <List>
                            {crew.members?.map(member => (
                                <ListItem key={member.userId._id}>
                                    <ListItemText 
                                        primary={`${member.userId.profile.firstName} ${member.userId.profile.lastName}`}
                                        secondary={member.isTemporary ? 'Temporary Assignment' : 'Permanent'}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    return (
        <Paper sx={{ p: 3 }}>
            {content}
        </Paper>
    )
}

export default CrewDetails
